import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import store from '../../app/Store';
import { UserModel } from './models/UserModel';
import { CustomAxiosRequestConfig } from 'src/services/axios/SetupAxios';
import { withPimURL } from 'src/helpers/service';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_AUTH_URL}`;
const PLATFORM = `${process.env.REACT_APP_PLATFORM}`;

const initialState: IAuthState = {
  user: undefined,
  token: undefined,
  refreshToken: undefined,
  userId: undefined,
  expireTime: undefined,
  profileUrl: undefined,
  requiredChangePassword: undefined,
  offerEnabled: undefined,
};

export interface IAuthState {
  user?: UserModel;
  token?: string;
  refreshToken?: string;
  userId?: number;
  expireTime?: number;
  profileUrl?: string;
  requiredChangePassword?: string;
  offerEnabled?: boolean;
}

export const refreshToken = createAsyncThunk('auth/refreshToken', async () => {
  const refreshToken = store.getState()?.auth?.refreshToken;
  const { headers, ip = '' } = await axios.get(withPimURL('/vendor/my-ip')).then((res) => res.data);
  const clientIp = headers?.['client-ip']?.[0] || ip || '';
  
  const res = await axios.post<any>(`${VENDOR_MC_URL}/refresh`, { refreshToken, platform: PLATFORM, clientIp: clientIp }, {
    skipToken: true,
  } as CustomAxiosRequestConfig);
  return res.data || {};
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    _login: (state, action: PayloadAction<IAuthState>) => {
      const accessToken = action.payload?.token;
      const refreshToken = action.payload?.refreshToken;
      const userId = action.payload?.userId;
      const expireTime = action.payload?.expireTime;
      const user = action.payload?.user;
      const profileUrl = action.payload?.profileUrl;
      const requiredChangePassword = action.payload?.requiredChangePassword;
      const offerEnabled = action.payload?.offerEnabled;
      state.user = user;
      state.token = accessToken;
      state.refreshToken = refreshToken;
      state.userId = userId;
      state.expireTime = expireTime;
      state.profileUrl = profileUrl;
      state.requiredChangePassword = requiredChangePassword;
      state.offerEnabled = offerEnabled;
    },
    setUser: (state, action: PayloadAction<IAuthState>) => {
      state.user = action.payload?.user;
      state.token = action.payload?.token;
      state.refreshToken = action.payload?.refreshToken;
      state.userId = action.payload?.userId;
      state.expireTime = action.payload?.expireTime;
      state.profileUrl = action.payload?.profileUrl;
      state.requiredChangePassword = action.payload?.requiredChangePassword;
      state.offerEnabled = action.payload?.offerEnabled;
    },
    _logOut: (state) => {
      state.user = undefined;
      state.token = undefined;
      state.refreshToken = undefined;
      state.userId = undefined;
      state.expireTime = undefined;
      state.profileUrl = undefined;
      state.requiredChangePassword = undefined;
      state.offerEnabled = undefined;
    },
    _refreshToken: (state, action: PayloadAction<IAuthState>) => {
      state.token = action.payload.token;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.refreshToken = action.payload.refreshToken;
      })
      .addCase(refreshToken.rejected, (state) => {});
  },
});

export const { _login, _logOut, setUser, _refreshToken } = userSlice.actions;
export default userSlice.reducer;
